import React, { Component } from "react";
import { Tabs, Tab } from "react-bootstrap";
import Areas from "../../pages/Areas";
import ClonagemLoja from "../../pages/ClonagemLoja";
import Promocoes from "../../pages/Promocoes";
import TiposEstabelecimento from "../../pages/TiposEstabelecimento";
import Usuarios from "../../pages/Usuarios";

export default class ControlledTabs extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      key: "Usuarios",
    };
  }

  render() {
    return (
      <div>
        <Tabs
          style={{ paddingTop: 7, marginTop: -1 }}
          id="controlled-tab-example"
          className="tabStyle"
          activeKey={this.state.key}
          onSelect={(key) => this.setState({ key })}
        >
          <Tab eventKey="Usuarios" title="Usuários" style={{ paddingLeft: 20 }}>
            <Usuarios></Usuarios>
          </Tab>
          <Tab eventKey="TiposEstabelecimento" title="Tipos de Estabelecimento">
            <TiposEstabelecimento />
          </Tab>
          <Tab eventKey="Areas" title="Áreas de Cobertura">
            <Areas></Areas>
          </Tab>
          <Tab eventKey="Promocoes" title="Banners de Promoções">
            <Promocoes></Promocoes>
          </Tab>
          <Tab eventKey="ClonagemLoja" title="Clonagem de Lojas">
            <ClonagemLoja></ClonagemLoja>
          </Tab>
        </Tabs>
      </div>
    );
  }
}
